import React, { useState } from 'react'

import '@fontsource/plus-jakarta-sans'

import { useLocation } from 'react-router'

import { BonoModal, Header, NavBar } from '..'
import { useUser, useModal } from '../../context'
import { useWindowSize } from '../../hooks/useWindowSize'
import { LayoutProps } from '../../types'

import { MainContent, MainContentNoUser, NavBarContainer } from './styles'

const Layout = ({ children, setClassToggle }: LayoutProps) => {
  const location = useLocation()
  const { userRole, loadingUser } = useUser()
  const { isDesktop } = useWindowSize()
  const { modalStatus } = useModal()

  const [isNavbarOpen, setIsNavbarOpen] = useState(false)

  const handleToggleNavbar = () => {
    setIsNavbarOpen(!isNavbarOpen)
  }

  return (
    !loadingUser && (
      <div
        className="container-fluid d-flex"
        style={{
          padding: 0,
          height: '100vh',
          justifyContent: userRole ? 'flex-end' : '',
        }}
      >
        {userRole ? (
          <>
            <NavBarContainer $showNavbar={isNavbarOpen}>
              <NavBar isOpen={isNavbarOpen} onToggle={handleToggleNavbar} />
            </NavBarContainer>

            <MainContent>
              {(!isDesktop || location.pathname !== '/initial-form') && (
                <Header title={userRole} setClassToggle={setClassToggle} />
              )}

              {modalStatus && <BonoModal />}

              {children}
            </MainContent>
          </>
        ) : (
          <MainContentNoUser>{children}</MainContentNoUser>
        )}
      </div>
    )
  )
}

export default Layout
